w<template>
    <div>
        <div class="widget_heading">
            <h5 class="text-white">
                <i class="fa fa-car" aria-hidden="true"></i>
                Nuevos Vehículos
            </h5>
        </div>
        <div class="recent_addedcars">
            <ul>
                <li
                    v-for="(vehiculo, index) in recienteslocal"
                    :key="index"
                    class="gray-bg"
                >
                    <div class="recent_post_img">
                        <a :href="`/ficha_tecnica/${vehiculo._id}?type=sellIn`"
                            ><img
                                :src="
                                    'https://d16vbrqyk5474c.cloudfront.net/fit-in/1280x720/' +
                                        vehiculo.fotos.foto_principal
                                "
                                alt="image"
                        /></a>
                    </div>
                    <div class="recent_post_title">
                        <a
                            :href="`/ficha_tecnica/${vehiculo._id}?type=sellIn`"
                            class="text-uppercase"
                        >
                            $ {{ vehiculo.precio | formatNumber }}
                        </a>
                        <p class="widget_price text-uppercase">
                            {{ vehiculo.marca }}
                            {{ vehiculo.linea }}
                            {{ vehiculo.modelo }}
                        </p>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";

export default {
    computed: {
        ...mapFields("buscador", ["recienteslocal"])
    },
    methods: {
        get_combustible(code_combustible) {
            switch (code_combustible) {
                case "GSL":
                    return "Gasolina";
                    break;
                case "DSL":
                    return "Diesel";
                    break;
                case "ELT":
                    return "Electrico";
                case "HBD":
                    return "Híbrido";
                    break;
                default:
                    return code_combustible;
            }
        },
        get_tipo_caja(code_caja) {
            switch (code_caja) {
                case "AT":
                    return "Automatica";
                    break;
                case "MT":
                    return "Mecanica";
                    break;
                case "TP":
                    return "Tiptronic";
                    break;
            }
        }
    }
};
</script>

<style lang="scss" scoped></style>
